import React from 'react';
import { Icon, Input, Form, Button, Label } from 'antd';
import { IBaseProps } from 'lib/data/interfaces';
import "./SetPassword.less";

const matching = (newpass: string, confirmpass: string): string => {
    if (confirmpass != "") {
        return newpass == confirmpass ? "lock" : "unlock";
    }
    return "unlock"

}
interface ISetPasswordProps extends IBaseProps {
    inputHandler(e): void
    newPassword: string;
    confirmPassword: string;
    resetPassword(): void;
}


export const SetPassword = (props: ISetPasswordProps) =>
    <Form className="login-form" onSubmit={(e) => e.preventDefault()}>
        <Form.Item>
            <Input className={matching(props.newPassword, props.confirmPassword)} addonBefore="Password" prefix={<Icon type={matching(props.newPassword, props.confirmPassword)} />} type="password" placeholder="new password" name="newPassword" onChange={props.inputHandler} value={props.newPassword} />
        </Form.Item>
        <Form.Item>

            <Input className={matching(props.newPassword, props.confirmPassword)} addonBefore="Confirm &nbsp;" prefix={<Icon type={matching(props.newPassword, props.confirmPassword)} />} type="password" placeholder="confirm password" name="confirmPassword" onChange={props.inputHandler} value={props.confirmPassword} />
        </Form.Item>
        <Form.Item className="action-wrapper">
            <div className="button-wrapper">
                <Button disabled={matching(props.newPassword, props.confirmPassword) == "unlock"} type="primary" htmlType="submit" className="login-form-button" onClick={props.resetPassword}>
                    Change Password
          		</Button>
            </div>
        </Form.Item>
    </Form>